export const ENABLE_LOCALES = ['zh', 'en', 'pt', 'es', 'ja'];

export const FALLBACK_LNG = 'zh';
